const gallery = [
    {
      '_id': '1',
      'image': '/images/1.webp',
    },
    {
      '_id': '2',
      'image': '/images/2.webp',  
    },
    {
      '_id': '3',
      'image': '/images/3.webp',
    },
    {
      '_id': '4',
      'image': '/images/4.webp',
    },
    {
      '_id': '5',
      'image': '/images/5.webp',  
    },
    {
      '_id': '6',
      'image': '/images/6.webp',    
    },
    {
      '_id': '7',
      'image': '/images/7.webp',
    },
    {
      '_id': '8', 
      'image': '/images/8.webp',
    },
    {
      '_id': '9',
      'image': '/images/9.webp',
    },
    {
      '_id': '10',
      'image': '/images/10.webp',
    },
    {
      '_id': '11',
      'image': '/images/11.webp',
    },
    {
      '_id': '12',
      'image': '/images/12.webp',
    },
    {
      '_id': '13',
      'image': '/images/13.webp',
    },
    {
      '_id': '14',
      'image': '/images/14.webp',
    },
    {
      '_id': '15',
      'image': '/images/15.webp',
    },
  ]
  
  
  export default gallery